module.exports = __webpack_public_path__ + "img/icon_tips0.bd24907e.svg";